<template>
  <div class="experience-list-container">
    <w-nav-bar nav_title="经历库" @mobileLeftBtn="pageBack"></w-nav-bar>
    <div class="experience-content">
      <div class="experience-header">
        <p class="title">从已有数据同步信息</p>
        <p class="description">您可以从历史创建的简历同步数据到当前简历</p>
      </div>
      <div class="scroll-container">
        <cube-scroll :data="ownModule">
          <template v-for="(item, index) in ownModule">
            <div class="module-item" :key="index" @click="changeDialogState(item)"
                 v-show="(item.experienceInfos.length || item.extrasCount) && item.type !== 'custom'">
              <div class="module-title flex-between">
                <span class="name">{{ item.title || item.name }}</span>
                <div class="experience-total flex-start">
                  <span class="count" v-if="item.type === 'extras'">
                    （{{ experienceCount(item) }}/{{ item.extrasCount }}）
                  </span>
                  <span class="count" v-else>
                    （{{ experienceCount(item) }}/{{ item.experienceInfos.length }}）
                  </span>
                  <span class="iconfont iconchevron-right"></span>
                </div>
              </div>
              <div v-if="item.type === 'extras' && experienceCount(item)" class="extras-content">
                <template v-for="(item, index) in extrasField">
                  <div class="extra-item" :key="index" v-if="pitchExtras[item]">
                    <p class="extra-description">{{ cv.submodule_info[`${item.slice(0, -1)}_title`] }}{{
                      pitchExtras[item].description }}</p>
                  </div>
                </template>
              </div>
              <list-component v-if="item.type !== 'extras'" :experience-data="item.experienceInfos"></list-component>
            </div>
          </template>
        </cube-scroll>
      </div>
    </div>
    <div class="experience-footer footer flex-center">
      <button class="experience-btn theme-button" @click="handleCreate" :disabled="!totalCount">同步</button>
    </div>
    <experience-dialog :state="dialogState" :title="title" @handleClose="handleClose"></experience-dialog>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import listComponent from './list-component'
	import experienceDialog from './experience-dialog'
	import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
	import { addClass } from '../../assets/js/dom'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'experience-list',
		mixins: [ componentsMixin ],
		data () {
			return {
				dialogState: false,
				ownModule: [],
				title: ''
			}
		},
		async mounted () {
			this.changeExperienceEnter(true)
			await this.getDetail()
			this.initSort()
		},
		computed: {
			...mapState('cv', [ 'cvSort', 'overageModule', 'cv' ]),
			...mapState('cvExperience', [ 'custom_ids', 'works', 'orgs', 'edus', 'personal_summary', 'project_experience', 'reasearch_experience', 'honor', 'skill_list', 'custom', 'extras' ]),
			...mapGetters('cvExperience', [ 'pitchExtras' ]),
			// extras 字段整合
			extrasField () {
				return Object.keys(this.pitchExtras)
			},
			// 当前一共选中的值
			totalCount () {
				let count = 0
				this.ownModule.forEach(item => {
					count += this.experienceCount(item)
				})
				return count
			}
		},
		watch: {
			dialogState (val) {
				if (!val) {
					this.$nextTick(() => {
						const els = document.querySelectorAll('.experience-description')
						els.forEach(item => {
							if (item.clientHeight > 88) {
								addClass(item, 'list-description')
							}
						})
					})
			  }
			}
		},
		components: {
			WNavBar,
			listComponent,
			experienceDialog
		},
		methods: {
			...mapActions('cvExperience', [ 'getExperience', 'getCustomExperience', 'getExtrasExperience' ]),
			...mapActions('cv', [ 'getCvDetail', 'createCvDetail' ]),
			...mapMutations('cvExperience', [ 'changeExperienceField', 'changeExperienceEnter' ]),
			// 返回
			pageBack () {
				this.$router.back()
			},
			// 同步简历
			async handleCreate () {
				let payload = JSON.parse(JSON.stringify(this.cv))
				let submoduleInfo = payload.submodule_info
				let basicInfo = payload.basic_info
				let custom_sections_titles = {}, custom_sections_ids = []
				// 从所有的模块里面拿出来有选择内容的模块
				const position = Array.from(new Set(
					[
						...this.cvSort,
						...this.ownModule.filter(item => {
							if (item.type !== 'extras') {
								return item.experienceInfos.findIndex(v => v.checked) !== -1
							} else {
								for (let i = 0; i < this.extrasField.length; i++) {
									if (this.pitchExtras[this.extrasField[i]]) return item
								}
							}
						})
					]
				))
				// 如果没有选择其他模块的内容，需要把payload里面的extras相关的id置空，否则就要填写所选的id
				this.extrasField.forEach(val => {
					submoduleInfo[`${ val.slice(0, -1) }_id`] = this.pitchExtras[val] ? this.pitchExtras[val].id : null
				})
				// 整合edu, org, work 的 ids
				position.forEach(item => {
					if (item.id) {
						if (item.experienceInfos.findIndex(v => v.checked) === -1) {
							item.info_ids = []
						} else {
							let ids = []
							item.experienceInfos.forEach(item => {
								if (item.checked) ids.push(item.id)
							})
							item.info_ids = ids
							item.id = this.custom_ids[`${ item.type }_id`]
						}
						custom_sections_ids.push(item.id)
					} else if (item.type !== 'extras') {
						let ids = []
						item.experienceInfos.forEach(val => {
							if (val.checked) ids.push(val.id)
						})
						submoduleInfo[`${ item.type }_ids`] = ids
						item.id = null
						item.info_ids = []
					} else {
						item.id = null
						item.info_ids = []
					}
					delete item.experienceInfos
					delete item.title
					delete item.position
					delete item.extrasCount
				})
				submoduleInfo.custom_sections_ids = custom_sections_ids
				submoduleInfo.custom_sections_titles = custom_sections_titles
				submoduleInfo.sections_position = position
				basicInfo.source_cv_token = basicInfo.token || null
				basicInfo['sample_cv_source_token'] = basicInfo.token || null // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
				basicInfo.kind = null
				basicInfo.token = null
				payload.operation_type = ''
				let res = await this.createCvDetail(payload)
				if (res.code === 3001) {
					this.showToast(res.message)
					return
				} else {
					this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
				}
			},
			// 关闭弹窗
			handleClose () {
				this.dialogState = false
			},
			// 选择经历
			changeDialogState (item) {
				this.changeExperienceField(item.type)
				this.title = item.title
				this.dialogState = true
			},
			// 返回当前经历里面所选择的经历个数
			experienceCount (item) {
				if (item.type === 'extras') {
					let count = 0
					for (let key in this.pitchExtras) {
						if (this.pitchExtras[key]) count += 1
					}
					return count
				} else {
					return item.experienceInfos && item.experienceInfos.filter(i => i.checked).length
				}
			},
			// 请求简历详情的数据
			async getDetail () {
				let token = this.$route.params.token
				if (this.cv && !Object.keys(this.cv).length) {
					await this.getCvDetail({ token })
				}
			},
			// 初始化经历的排序
			async initSort () {
				const langPayload = { lang: this.cv.basic_info.lang }
				const sectionLangPayload = { section_lang: this.cv.basic_info.lang }
				const expArg = { template: this.cvSort.map(i => i.type) }
				await Promise.all([
					this.getExperience({ ...expArg, payload: langPayload, moduleName: 'edus', apiMethod: 'getEduExperience' }),
					this.getExperience({ ...expArg, payload: langPayload, moduleName: 'orgs', apiMethod: 'getOrgExperience' }),
					this.getExperience({ ...expArg, payload: langPayload, moduleName: 'works', apiMethod: 'getWorkExperience' }),
					this.getExperience({ ...expArg, payload: langPayload, moduleName: 'opus', apiMethod: 'getOpuExperience' }),
					this.getCustomExperience({ ...expArg, payload: langPayload }),
					this.getExtrasExperience({ ...expArg, payload: sectionLangPayload })
				])
				let overage = JSON.parse(JSON.stringify(this.overageModule))
				overage.forEach(item => {
					item.id = this.custom_ids[`${ item.type }_id`] || item.id
				})
				let ownModule = [ ...this.cvSort, ...overage ]
				let hasExperienceCount = 0
				ownModule.forEach(item => {
					item.experienceInfos = this[item.type] || []
					if (item.type === 'extras') {
						item.extrasCount = 0
						item.title = this.cv.submodule_info.extras_title
						for (let key in item.experienceInfos) {
							if (item.experienceInfos[key].length) {
								item.extrasCount += 1
							}
						}
						hasExperienceCount += item.extrasCount
					} else if (item.id) {
						item.title = this.cv.submodule_info.custom_sections_titles[`${ item.id }_title`] || item.title
						hasExperienceCount += item.experienceInfos.length
					} else {
						item.title = this.cv.submodule_info[`${ item.type }_title`] || item.title
						hasExperienceCount += item.experienceInfos.length
					}
				})
				if (!hasExperienceCount) this.$router.back()
				this.ownModule = ownModule
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '../../assets/scss/global/variable';
  @import '../../assets/scss/global/mixin';
  .experience-list-container {
    padding: 0 24px;
    @include mobile-container(44px, 78px);
    .experience-content {
      padding-top: 24px;
      .experience-header {
        margin-bottom: 24px;
        .title {
          font-size: $font-size-large-x;
					font-weight: 600;
          color: $color-title;
          line-height: 20px;
          margin-bottom: 14px;
        }
        .description {
          color: #9C9C9C;
        }
      }
      .scroll-container {
        // 为了兼容iphone11.2前后的系统，需要写两个高
        height: calc(calc(var(--vh, 1vh) * 100) - 226px - constant(safe-area-inset-bottom);
        height: calc(calc(var(--vh, 1vh) * 100) - 226px - env(safe-area-inset-bottom);
      }
      .module-item {
        .module-title {
          color: $color-title;
          height: 46px;
          margin-bottom: 0px;
          .iconfont {
            color: #9c9c9c;
            font-weight: 600;
          }
        }
        /deep/ .experience {
          &:first-child {
            margin-top: 0;
          }
        }
        .extras-content {
          padding: 20px;
          background-color: #f9f9f9;
          border-radius: 8px;
          .extra-item {
            margin-bottom: 8px;
            color: $color-dark-gray;
            .extra-description {
              @include ellipsis(calc(100vw - 84px));
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .experience-footer {
      width: 100vw;
      padding: 0 24px;
      background-color: $color-light;
      @include ipx-footer(78px, 1px);
      z-index: 19;
      .experience-btn {
        width: 100%;
        height: 46px;
        border-radius: 4px;
        font-size: $font-size-medium-x;
        &:disabled {
          background-color: #CFCFCF;
          color: $color-light;
        }
      }
    }
  }
</style>
